import { useState } from "react";
import "./PopularTours.css";
import Button from "../Button/Button";
import { popularTourSlides } from "../../data/tours";

const slides = popularTourSlides;

function PopularTours() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const slide = slides[currentSlide];

  return (
    <div className="popular-tours">
      <h1>
        OUR POPULAR <br />
        TOURS
      </h1>
      <div className="popular-content">
        <div className="popular-left">
          <div
            className="img"
            style={{ backgroundImage: `url(${slide.img})` }}
          >
            <h5>{slide.place}</h5>
          </div>
          <div className="text">
            <div>
              <h2>{slide.title}</h2>
              <h5>{slide.subtitle}</h5>
              <p>{slide.description}</p>
            </div>
            <Button buttonName="RESERVE A TRIP" to="/packages" />
          </div>
        </div>
        <div className="popular-right">
          <div className="arrows">
            <button className="arrow-left" onClick={prevSlide}>
              &lt;
            </button>
            <button className="arrow-right" onClick={nextSlide}>
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopularTours;
